import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect, useRef } from "react";

interface QrScanProps {
  fps: number;
  qrbox: number;
  disableFlip?: boolean;
  hidden?: boolean;
  instanceId?: number;
  qrCodeSuccessCallback: (decodedText: string, decodedResult: unknown) => void;
}

const Html5QrcodePlugin = ({
  fps,
  qrbox,
  disableFlip,
  hidden,
  instanceId,
  qrCodeSuccessCallback,
}: QrScanProps) => {
  const elementId =
    instanceId !== undefined
      ? `html5qr-code-full-region-${instanceId}`
      : "html5qr-code-full-region";

  // Ref keeps callback fresh without triggering scanner re-init on each render
  const successRef = useRef(qrCodeSuccessCallback);
  useEffect(() => {
    successRef.current = qrCodeSuccessCallback;
  });

  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      elementId,
      { fps, qrbox, disableFlip: disableFlip ?? false },
      false,
    );
    scanner.render(
      (...args) => successRef.current(...args),
      () => {},
    );
    return () => {
      scanner
        .clear()
        .catch((err) => console.error("Failed to clear scanner:", err));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementId]);

  return (
    <div
      id={elementId}
      style={{
        display: hidden ? "none" : "block",
        opacity: hidden ? 0 : 1,
        pointerEvents: hidden ? "none" : "auto",
      }}
    />
  );
};

export default Html5QrcodePlugin;
